import React from 'react';
import Modal from 'react-modal';
import {
    ConsumerPrice,
    OrgPrice,
    DescInput,
    Select,
    TextLine,
    StickyBtm,
    BtnFullModal,
    JoinField,
    PadVert10,
    Fz15Bold,
    InputWrapper,
    JoinInputPlc15,
    FlxbtFull,
    FlxMiddle,
    Fz15,
    PadVert30,
    ContainerFit,
    Fz20Bold,
    Fz16Medium,
    AddContainer,
    TextLineAutosize,
} from '@/css/style';
import { onlyNum } from '@/utils/helper';
import { useDesignerMenuCreateMutation } from '@/services/designerService';
import useServiceStore from '@/stores/designer/service';
import useUserStore from '@/stores/user/user';
import icCloseModal from '@/assets/img/ic_close_modal_gray.svg';
import { useIsMutating } from '@tanstack/react-query';

export default function ServiceAdd({ isOpen, closeModal, category, refetch }) {
    const us = useUserStore();
    const ss = useServiceStore();
    const isMutating = useIsMutating();
    const DesignerMenuCreateMutation = useDesignerMenuCreateMutation(() => {
        refetch();
        ss.terminate();
        closeModal();
    });

    const validate =
        parseInt(ss.service.normal_price) >= parseInt(ss.service.price) &&
        ss.service.category_id &&
        ss.service.name;

    const serviceAdd = () => {
        if (!validate) {
            return;
        } else {
            DesignerMenuCreateMutation.mutate({
                designerId: us.user.id,
                params: { ...ss.service },
            });
        }
    };
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="시술 메뉴 등록"
            className={'service-menu'}
            $visible
        >
            <AddContainer>
                <button onClick={closeModal}>
                    <img src={icCloseModal} alt="닫기" />
                </button>
                <PadVert30>
                    <Fz20Bold>시술 메뉴 등록</Fz20Bold>
                </PadVert30>
                <JoinField>
                    <PadVert10>
                        <Fz15Bold>시술 메뉴 선택</Fz15Bold>
                    </PadVert10>
                    <InputWrapper>
                        <Fz15
                            as={Select}
                            onChange={(e) => ss.setService('category_id', e.target.value)}
                        >
                            <option value="">선택</option>
                            {category?.data.map((category) => (
                                <option key={category.id} value={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </Fz15>
                    </InputWrapper>
                </JoinField>
                <JoinField>
                    <PadVert10>
                        <Fz15Bold>시술명</Fz15Bold>
                    </PadVert10>
                    <InputWrapper>
                        <JoinInputPlc15
                            type="text"
                            id="serviceName"
                            name="serviceName"
                            maxLength="15"
                            value={ss.service.name}
                            onChange={(e) => ss.setService('name', e.target.value)}
                            placeholder="이름을 입력해 주세요"
                        />
                    </InputWrapper>
                </JoinField>
                <JoinField>
                    <PadVert10>
                        <Fz15Bold>시술 설명</Fz15Bold>
                    </PadVert10>
                    <InputWrapper>
                        <TextLineAutosize
                            cacheMeasurements
                            value={ss.service.option}
                            placeholder="설명을 입력해 주세요 ex) 기장추가"
                            minRows={1.5}
                            maxRows={8}
                            maxLength="300"
                            onChange={(e) => ss.setService('option', e.target.value)}
                        ></TextLineAutosize>
                        {/* <TextLine
                            rows="8"
                            placeholder="설명을 입력해 주세요 ex) 기장추가"
                            value={ss.service.option}
                            onChange={(e) => ss.setService('option', e.target.value)}
                            maxLength="300"
                        ></TextLine> */}
                    </InputWrapper>
                    <DescInput $pt="1.154rem">300자 이하로 입력 가능합니다.</DescInput>
                </JoinField>
                <JoinField>
                    <PadVert10>
                        <Fz15Bold>정가</Fz15Bold>
                    </PadVert10>
                    <InputWrapper>
                        <JoinInputPlc15
                            type="text"
                            id="serviceOrgPrice"
                            name="serviceOrgPrice"
                            maxLength="10"
                            value={
                                ss.service.normal_price
                                    ? ss.service.normal_price.toLocaleString()
                                    : ''
                            }
                            onChange={(e) =>
                                ss.setService(
                                    'normal_price',
                                    e.target.value.trim() === ''
                                        ? ''
                                        : parseInt(onlyNum(e.target.value))
                                )
                            }
                        />
                        <Fz15 $col="#000">원</Fz15>
                    </InputWrapper>
                    <DescInput $pt="1.154rem">미 입력시 무료로 설정됩니다.</DescInput>
                </JoinField>
                {ss.service.normal_price ? (
                    <JoinField>
                        <PadVert10>
                            <Fz15Bold>판매가</Fz15Bold>
                        </PadVert10>
                        <InputWrapper>
                            <JoinInputPlc15
                                type="text"
                                id="servicePrice"
                                name="servicePrice"
                                maxLength="10"
                                value={ss.service.price ? ss.service.price.toLocaleString() : ''}
                                onChange={(e) =>
                                    ss.setService(
                                        'price',
                                        e.target.value.trim() === ''
                                            ? ''
                                            : parseInt(onlyNum(e.target.value))
                                    )
                                }
                            />
                            <Fz15 $col="#000">원</Fz15>
                        </InputWrapper>
                        <DescInput $pt="1.154rem">
                            할인 가격을 등록하시면 할인 가격으로 판매됩니다.
                        </DescInput>
                    </JoinField>
                ) : null}
                {ss.service.normal_price !== ss.service.price ? (
                    <FlxbtFull>
                        <Fz16Medium $col="#FF3062">
                            {ss.service.normal_price && ss.service.price && (
                                <>
                                    {Math.ceil(
                                        ((ss.service.normal_price - ss.service.price) /
                                            ss.service.normal_price) *
                                            100
                                    )}
                                    %
                                </>
                            )}
                        </Fz16Medium>
                        {ss.service.normal_price && ss.service.price ? (
                            <FlxMiddle>
                                <OrgPrice>{ss.service.normal_price}원</OrgPrice>
                                <ConsumerPrice>{ss.service.price}원</ConsumerPrice>
                            </FlxMiddle>
                        ) : (
                            <FlxMiddle>
                                <ConsumerPrice>{ss.service.normal_price}원</ConsumerPrice>
                            </FlxMiddle>
                        )}
                    </FlxbtFull>
                ) : null}
                <BtnFullModal
                    $active={
                        parseInt(ss.service.normal_price) >= parseInt(ss.service.price) &&
                        ss.service.category_id
                    }
                    onClick={() => serviceAdd()}
                    disabled={!!isMutating}
                >
                    등록
                </BtnFullModal>
            </AddContainer>
            {/* <StickyBtm>
                <BtnFullModal
                    $active={
                        parseInt(ss.service.normal_price) >= parseInt(ss.service.price) &&
                        ss.service.category_id
                    }
                    onClick={() => serviceAdd()}
                    disabled={!!isMutating}
                >
                    등록
                </BtnFullModal>
            </StickyBtm> */}
        </Modal>
    );
}
const customStyles = {
    content: {
        position: 'absolute',
        right: 'unset',
        bottom: 'unset',
        border: '0px',
        background: 'rgb(255, 255, 255)',
        borderRadius: '0px',
        outline: 'none',
        padding: '0px',
        zIndex: '20',
        height: '100%',
        top: 0,
        left: 'calc(44rem + 50vw)',
        width: '100%',
        maxWidth: '440px',
        height: '100%',
        transform: 'translateX(-50%)',
        overflow: 'auto',
        marginLeft: '-22rem',
    },
};
